import { useHistory, useParams } from 'react-router-dom'
import useTranslation from 'hooks/useTranslation'
import Error from 'components/Error'
import React from 'react'

interface MagAccessoriesProps {

}

const MagAccessories: React.FC<MagAccessoriesProps> = () => {
  const { id } = useParams<{ id: string }>()

  const { push } = useHistory()
  const { t } = useTranslation('warehouse')

  return (
    <div className='menu__section'>
      <div className='menu__accessories'>
        <div className='menu__accessories__menu'>
          <div
            className='menu__accessories__menu__item'
            onClick={() => {

            }}>
            <div className='group'>
              <i className='icon icon--how-its-work' />
              <div className='menu__accessories__menu__item__circle'>
              <i className='icon icon--arrow-right' />
              </div>
            </div>
            <div className='menu__accessories__menu__item__title'>{t('howItWorks')}</div>
          </div>
          <div
            className='menu__accessories__menu__item'
            onClick={() => {
              push(`/shop/${id}`)
            }}>
            <div className='group'>
              <i className='icon icon--shopping-bag' />
              <div className='menu__accessories__menu__item__circle'>
                <i className='icon icon--arrow-right' />
              </div>
            </div>
            <div className='menu__accessories__menu__item__title'>{t('orderAccessories')}</div>
          </div>
        </div>

        <div className='menu__accessories__list'>
          <p>{t('yourAccessories')}</p>
          <Error
            staticPos
            text={t('none')}
          />
        </div>
      </div>
    </div>
  )
}

export default MagAccessories